import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-cancel',
  imports: [],
  templateUrl: './player-profile-payment-cancel.component.html',
  styleUrl: './player-profile-payment-cancel.component.scss'
})
export class PlayerProfilePaymentCancelComponent
{

}
